import getDefaultState from './defaultState'
const state = getDefaultState()

export default state
